module.exports = __webpack_public_path__ + "static/media/Reporting12.66a093b3.png";